import React, { useCallback, useMemo } from 'react';
import { Button, Card } from 'react-bootstrap';
import { Copy, CursorText } from 'react-bootstrap-icons';
import { LOGO_SRC } from '../helpers/logo';
import { getFirstName, getLastName } from '../helpers/person';
import { getInstructorRank, getScoutRank } from '../helpers/rank';
import { Person, Rank } from '../types/form';
import './FooterContent.css';

interface FooterContentProps {
  email: string | null;
  emailValid: boolean;
  person: Person;
  phone: string | null;
  position: string | null;
  rank: Rank;
}

function FooterContent({ email, emailValid, person, phone, position, rank }: FooterContentProps) {
  const copyingAvailable = useMemo(() => !!document.execCommand, []);
  const copyFooterContent = useCallback(() => {
    const element = document.getElementById('footer-content');
    if (element) {
      const range = document.createRange();
      range.selectNodeContents(element);
      const selection = window.getSelection();
      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
        if (copyingAvailable) {
          document.execCommand('copy');
          selection.removeAllRanges();
        }
      }
    }
  }, [copyingAvailable]);

  return (
    <div className="FooterContent">
      <Card bg="secondary" text="white" className="rounded-3 shadow-sm">
        <Card.Header className="py-3 text-center">
          <h4 className="my-0">Wygenerowana stopka - skopiuj wyłącznie zawartość poniszej ramki:</h4>
        </Card.Header>
        <Card.Body>
          <div id="footer-content" className="FooterContent-value">
            <div style={{
              borderBottom: '1px solid rgb(204, 204, 204)',
              color: '#000',
              font: '12px/1.5 "Trebuchet MS", Trebuchet, sans-serif, serif',
              padding: '0 0 10px',
            }}>
              <strong>
                Pozdrawiam,<br />
                {getInstructorRank(person, rank.instructor)}{' '}
                {person.firstName || getFirstName(person)}{' '}
                {person.lastName || getLastName(person)}{' '}
                {getScoutRank(person, rank.scout, false)}<br />
              </strong>
              {position ?
                position.trim().replace(/\r\n|\r/, '\n').split('\n').map(line => <>{line}<br /></>) :
                null}<br />
              ZHP Chorągiew Krakowska im. Tadeusza Kościuszki<br />
              ul. Karmelicka 31, 31-131 Kraków<br />
              {phone ?
                <>
                  tel. <a href={`tel:${phone.startsWith('+') ? '+' : ''}${phone.replace(/[^0-9]/g, '')}`}>
                    {phone}
                  </a><br />
                </> :
                null}
              {email && emailValid ?
                <>
                  e-mail <a href={`mailto:${email}`}>{email}</a><br />
                </> :
                null}
            </div>
            <img src={LOGO_SRC} alt="ZHP Chorągiew Krakowska" style={{ margin: '10px 0 0' }} />
          </div>
          <Button className="FooterContent-select" onClick={copyFooterContent} variant="outline-primary">
            {copyingAvailable ?
              <><Copy /> Kopiuj do schowka</> :
              <><CursorText /> Zaznacz wszystko</>}
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
}

export default FooterContent;
